"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuLabelWithUnit = exports.MenuLabel = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const menu_styled_1 = require("./menu.styled");
const StyledUnit = styled_components_1.default.div.withConfig({ displayName: "reports-StyledUnit", componentId: "reports-vxegw1" }) `
  display: flex;
  align-items: center;
  justify-content: flex-end;
  font-weight: bold;
`;
const MenuLabel = ({ title, value }) => {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        title && react_1.default.createElement(menu_styled_1.StyledText, null, title),
        (value || value === 0) && (react_1.default.createElement(menu_styled_1.StyledText, { "$bold": true, "$align": "right" }, value))));
};
exports.MenuLabel = MenuLabel;
exports.default = (0, styled_components_1.default)(exports.MenuLabel).withConfig({ componentId: "reports-1tcd4xa" }) ``;
exports.MenuLabelWithUnit = (0, styled_components_1.default)(({ title, value, unit, }) => {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(menu_styled_1.StyledText, null, title),
        react_1.default.createElement(StyledUnit, null, unit),
        react_1.default.createElement(menu_styled_1.StyledText, { "$bold": true, "$align": "right" }, value)));
}).withConfig({ displayName: "reports-MenuLabelWithUnit", componentId: "reports-946y7u" }) ``;
//# sourceMappingURL=menu-label.js.map